import { BsGlobe2, BsExclamationDiamondFill } from "react-icons/bs";
import { IoEllipse } from "react-icons/io5";
import { TbWorld } from "react-icons/tb";
import { useTranslation } from "react-i18next";
const PrivacyBadge = ({privacy,isYourProfile})=>{
    const { t } = useTranslation();
    return (
        <>
        {  isYourProfile && 
            <>
            {/* <p>
                <IoEllipse className="w-1 h-1" />
            </p> */}
                {/* <p className="flex items-center capitalize mr-3"> */}
                <p className="flex items-center capitalize">
                    {privacy === "Public" ? (
                    <BsGlobe2 className="mr-1.5" />
                    ) : (
                    <BsExclamationDiamondFill className="mr-1.5" />
                    )}
                    {privacy === "Public" ? t('public') : t('private')}
                </p>
            {/* <p>
                <IoEllipse className="w-1 h-1" />
            </p> */}
            </>
        }
        </>
    );
}

export default PrivacyBadge;